





























































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { FClass } from "@/data/furniture/Physical";
import { Furniture, Status } from "@/data/Furniture";
import DatePickerMenu from "@/components/DatePickerMenu.vue";

@Component({ components: { DatePickerMenu } })
export default class FurnitureTableFilters extends Vue {
  @Prop({})
  readonly startDateFilter!: string;

  @Prop({})
  readonly endDateFilter!: string;

  @Prop({})
  readonly statusFilter!: string[];

  @Prop({})
  readonly classFilter!: string[];

  @Prop({})
  readonly donorFilter!: string[];

  @Prop({})
  readonly zoneFilter!: string[];

  @Prop({})
  readonly inventory!: Furniture[];

  readonly classCheckboxes = Object.keys(FClass);

  readonly statusCheckboxes = Object.values(Status)
    .filter((v) => typeof (v as any) !== "number")
    .map((value, index) => {
      return { text: value, value: index };
    });

  get donorOptions(): any {
    return this.inventory.map((x) => x.donor.name);
  }

  get zoneOptions(): any {
    return this.inventory.map((x) => x.donor.zone);
  }

  filterChips = [] as string[];

  showFilter = false;

  startOpen = false;

  endOpen = false;

  today = new Date().toISOString().substr(0, 10);

  static filterType(f: string): string {
    if (f === "StartDate" || f === "EndDate") {
      return "Date";
    }
    return f;
  }

  update(filter: string, value: string[]): void {
    switch (filter) {
      case "StartDate":
        this.startOpen = false;
        this.$emit("startdate", value);
        break;
      case "EndDate":
        this.endOpen = false;
        this.$emit("enddate", value);
        break;
      case "Class":
        this.$emit("class", value);
        break;
      case "Status":
        this.$emit("status", value);
        break;
      case "Donor":
        this.$emit("donor", value);
        break;
      case "Zone":
        this.$emit("zone", value);
        break;
      default:
      // do something
    }
    this.updateChip(filter, value);
  }

  updateChip(filter: string, value: any): void {
    const adjustedFilter = FurnitureTableFilters.filterType(filter);
    if (!this.filterChips.includes(adjustedFilter)) {
      if (
        (filter === "Class" && value.length !== this.classCheckboxes.length) ||
        (filter === "Status" &&
          value.length !== this.statusCheckboxes.length) ||
        (filter === "Donor" && value.length !== 0) ||
        (filter === "Zone" && value.length !== 0) ||
        (filter === "StartDate" && value !== this.today) ||
        (filter === "EndDate" && value !== "")
      ) {
        this.filterChips.push(adjustedFilter);
      }
    } else if (
      (filter === "Class" && value.length === this.classCheckboxes.length) ||
      (filter === "Status" && value.length === this.statusCheckboxes.length) ||
      (filter === "Donor" && value.length === 0) ||
      (filter === "Zone" && value.length === 0) ||
      (filter === "StartDate" &&
        value === this.today &&
        this.endDateFilter === "")
    ) {
      this.filterChips.splice(
        this.filterChips.findIndex((x) => x === adjustedFilter),
        1,
      );
    }
  }

  closeChip(filter: string, index: number): void {
    this.filterChips.splice(index, 1);
    if (filter === "Class") {
      this.$emit("class", this.classCheckboxes);
    } else if (filter === "Status") {
      this.$emit(
        "status",
        this.statusCheckboxes.map((x) => x.value),
      );
    } else if (filter === "Date") {
      this.$emit("startdate", "");
      this.$emit("enddate", this.today);
    } else if (filter === "Donor") {
      this.$emit("donor", []);
    } else if (filter === "Zone") {
      this.$emit("zone", []);
    }
  }
}
